<div class="container-fluid p-4">
  <div class="row justify-content-center">
    <div class="col d-flex">
      <groundworks-listbox class="flex-grow-1" [title]="'Pending Sales'" [tabs]="tabs()" [config]="tableConfig"
        [items]="pendingSales" [loading]="isLoading()" [error]="errorMessage()" [noDataMessage]="noDataMessage()"
        [showSettings]="showSettings()" (actionClick)="handleAction($event)" (settingsClick)="handleSettingsClick()" />
      <app-side-modal #sideModal class="mt-5" (filtersChanged)="onFiltersChanged($event)" />
    </div>
  </div>
</div>
